export default __webpack_public_path__ + "static/media/rafa3.77289228.jpg";